import getLanguage from './getLanguage';

/**
 * This function is copied from the CandyRack.
 *
 * Returns the active storefront locale in uppercase format compatible with the Shopify Storefront API.
 *
 * This function detects the current language using supported translation apps (e.g., Weglot, Langify)
 * or falls back to `window.Shopify.locale`, then normalizes the result for use in Shopify GraphQL queries.
 *
 * Shopify Storefront API expects locales in `xx_YY` format (e.g., 'EN_US', 'FR_CA').
 * While Shopify typically uses only one hyphen (e.g., 'en-US'), we defensively replace **all** hyphens
 * to support non-standard or injected locale formats like 'zh-Hans-CN'.
 *
 * @returns A locale string in uppercase `XX_YY` format, or an empty string if the locale cannot be resolved.
 *
 * @example
 * // If the current locale is 'en-US'
 * getShopifyGraphQLUpperLocale(); // 'EN_US'
 *
 */
const getShopifyGraphQLUpperLocale = (): string => {
  const rawLocale = getLanguage();

  // Replace all hyphens just in case a non-standard locale like 'zh-Hans-CN' is injected.
  // Normally, Shopify locales only include one hyphen: 'en-US', 'fr-CA', etc.
  return rawLocale?.replaceAll('-', '_').toUpperCase() || '';
};

export default getShopifyGraphQLUpperLocale;
